function Dipespsistemasadministrativaestado(){
     return(
        <div className="contenedor">
            <div className="presentacion"> 
               <h1> Presentación </h1>
               <p>
                    El Diploma de Especialización en Sistemas Administrativos del Estado 
                    brinda una formación integral y actualizada sobre los principales sistemas 
                    que regulan la gestión pública, desarrollando competencias técnicas para 
                    su correcta aplicación en el ámbito institucional.
               </p>
               <p>
                    El programa aborda contenidos vinculados al Sistema Nacional de Presupuesto, 
                    Tesorería, Contabilidad, Abastecimiento, Recursos Humanos, Control y Planeamiento, 
                    promoviendo una visión articulada e integrada de la gestión administrativa 
                    del Estado bajo criterios de eficiencia, legalidad y transparencia.
               </p>

                <ul>
                    <h1> Objetivo Específico </h1>
                    <ul>
                        <li>
                            Desarrollar competencias técnicas para aplicar correctamente la normativa 
                            y procedimientos de los Sistemas Administrativos del Estado, fortaleciendo 
                            la gestión institucional mediante una administración eficiente, articulada 
                            y orientada al cumplimiento de metas y resultados.
                        </li>
                    </ul>
                </ul>
            </div>

            <div className="metedologia">
                <img 
                    src='/uploads/curs_gestion_municipal.jpg' 
                    alt='logo-de-metodologia' 
                    className='logo-metodologia'
                />
                
                <ul> 
                    <li>
                        <h1> Informes </h1>
                        <p>Escuela de Gerencia y Gestión S.A.C</p>
                        <p>📱 Teléfonos y WhatsApp: 913376365 / 948251685</p>
                        <p>📧 Correos: esscuelag@gmail.com | capacita@escuelag.com</p>
                    </li>
                </ul>
            </div>

            <div className="temario-principal">
                <h1> Áreas Temáticas </h1>
                <ul>
                    <li> 1. Sistema Nacional de Presupuesto </li>
                    <li> 2. Sistema Nacional de Tesorería </li>
                    <li> 3. Sistema Nacional de Contabilidad </li>
                    <li> 4. Sistema Nacional de Abastecimiento </li>
                    <li> 5. Sistema Administrativo de Recursos Humanos </li>
                    <li> 6. Sistema de Control y Planeamiento </li>
                </ul>
            </div>
        </div>
    );
}
export default  Dipespsistemasadministrativaestado
